import { createFileRoute } from '@tanstack/react-router'
import { SubjectDetailPage } from 'pages/facilityModel/SubjectDetailPage'
import { facilityModelSubjectSearchParams } from 'routes/facility-model/-searchParams'

const RouteComponent = () => {
  const { subjectUid } = Route.useParams()
  const { siteId } = Route.useSearch()
  return <SubjectDetailPage siteId={siteId ?? null} subjectUid={subjectUid} />
}

export const Route = createFileRoute('/facility-model/subjects/$subjectUid')({
  component: RouteComponent,
  validateSearch: facilityModelSubjectSearchParams,
  staticData: {
    title: 'Subject',
    layout: {
      enableScrolling: false,
    },
  },
})
